import React from 'react';
import { IconButton, ListItem, ListItemText, SxProps } from '@mui/material';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { getFileNameWithExtension } from 'core/services/storage/utils';
import { Loading } from 'components/Loading';
import { Attachment } from 'services/conversations/types';
import { getMediaFileName } from 'modules/conversations/utils';

const fileItemContainer: SxProps = {
  borderColor: 'customGrey.light',
  borderWidth: 1,
  borderStyle: 'solid',
  my: 1,
  borderRadius: 0.5,
  backgroundColor: 'white'
};

const AttachmentItem = ({
  attachment,
  downloadFile
}: {
  attachment: Attachment;
  downloadFile: ({
    attachmentId,
    fileName
  }: {
    attachmentId: string;
    fileName: string;
  }) => void;
}) => {
  const [isLoading, setIsLoading] = React.useState(false);

  return (
    <ListItem sx={fileItemContainer}>
      <ListItemText
        primary={getFileNameWithExtension(
          getMediaFileName(attachment.media),
          attachment.media.contentType
        )}
        primaryTypographyProps={{
          sx: {
            overflow: 'hidden',
            textOverflow: 'ellipsis'
          }
        }}
      />
      <IconButton
        onClick={async () => {
          setIsLoading(true);
          await downloadFile({
            attachmentId: attachment.id,
            fileName: getMediaFileName(attachment.media)
          });
          setIsLoading(false);
        }}
        sx={{
          ml: 1,
          color: 'text.primary'
        }}
      >
        {isLoading ? <Loading size={20} /> : <FileDownloadOutlinedIcon />}
      </IconButton>
    </ListItem>
  );
};

export { AttachmentItem };
